export default __webpack_public_path__ + "static/media/op-ku-picturemark-l.2700de87.svg";